import { webviewInfo, os, bridge } from '@ali/amap-lib';
import $ from './zepto';
import MsgBox from './msgbox';
import ignore from '../../config/config.ignore.js';

class AmapDebug {
  constructor() {
    this.isInAmap = true;
    if (window.AMAP_WEBSOCKET || process.mock) {
      this.isInAmap = webviewInfo.isInAmap();
      // 判断当前页面所在的容器环境
      if (this.isInAmap && os.android) {
        this.debugInAmapAndroid();
      } else if (this.isInAmap && os.ios) {
        this.debugInAmapIos();
      } else {
        this.debugInBrower();
      }
    }
    console.log('[debug in amap] ', this.isInAmap);
  }

  shouldMock(action) {
    let mock = true;
    if (ignore.action === true && action !== 'aosrequest') {
      mock = false;
    }

    if (Array.isArray(ignore.action) && ignore.action.indexOf(action) !== -1) {
      mock = false;
    }

    if (ignore.aos === true && action === 'aosrequest') {
      mock = false;
    }

    if (Array.isArray(ignore.aos) && ignore.aos.indexOf(action) !== -1) {
      mock = false;
    }
    return mock;
  }

  /**
   * 端内安卓webview
   */
  debugInAmapAndroid() {
    const _this = this;
    let invokeMethodCopy = () => {};
    if (window.jsInterface && jsInterface.invokeMethod) {
      invokeMethodCopy = window.jsInterface.invokeMethod.bind(
        window.jsInterface
      );
    }
    window.jsInterface = {
      invokeMethod(...params) {
        const param = JSON.parse(params[1][0]);
        const { action } = param;
        const mock = _this.shouldMock(action);
        if (mock) {
          _this.mockCallBack(param);
        } else {
          invokeMethodCopy(...params);
        }
      }
    };
  }

  /**
   * 端内ios webview
   */
  debugInAmapIos() {
    bridge.ready(() => {
      const readyEvent = window.WebViewJavascriptBridge;
      const oldSend = readyEvent.send;
      readyEvent.send = (...params) => {
        const { action } = params[0];
        if (!this.shouldMock(action)) {
          oldSend(...params);
        } else {
          this.mockCallBack(...params);
        }
      };
    });
  }

  /**
   * 端外浏览器，所有接口走mock数据
   */
  debugInBrower() {
    if (os.android) {
      const _this = this;
      window.jsInterface = {
        invokeMethod(...params) {
          const param = JSON.parse(params[1][0]);
          _this.mockCallBack(param);
        }
      };
    }
    document.addEventListener('DOMContentLoaded', () => {
      const readyEvent = document.createEvent('Events');
      readyEvent.initEvent('WebViewJavascriptBridgeReady');
      readyEvent.bridge = {
        /**
         * 两个参数，但ios下调用此方法传的参数都一样
         * 因为ios下主动回调的方法不需要主动请求，所以需要在这里进行处理
         */
        init() {},
        registerHandler() {},
        send: this.mockCallBack
      };
      document.dispatchEvent(readyEvent);
    });
  }

  /**
   * mock返回统一处理
   */
  mockCallBack = (obj) => {
    const { connectNative } = this;
    const handler = window.callback || window.callbacks || window.jsWebviewHandler;
    let path = '';
    if (window.AMAP_WEBSOCKET && !window.AMAP_WEBSOCKET_MOCK) {
      window.amap_chrome.send(obj);
      return;
    }
    switch (obj.action) {
      case 'aosrequest':
        this.callAosHandler(this.fixURL(obj.urlPrefix), obj, handler);
        break;
      case 'getAmapUserId':
        if (obj.onlyGetId * 1 === 1) {
          path = `${obj.action}.json`;
          connectNative(path, obj, handler);
        } else {
          MsgBox({
            content: '是否已经登录',
            btns: [
              {
                text: '是',
                fun() {
                  handler({
                    userid: 1222,
                    _action: obj._action
                  });
                }
              },
              {
                text: '否',
                fun() {
                  handler({
                    userid: '',
                    _action: obj._action
                  });
                }
              }
            ]
          });
        }
        break;
      case 'loginBind':
        MsgBox({
          content: '是否已经登录？',
          btns: [
            {
              text: '是',
              fun() {
                if (obj.type == 'phone') {
                  MsgBox({
                    content: '是否已经绑定手机号？',
                    btns: [
                      {
                        text: '是',
                        fun() {
                          handler({
                            userid: 1222,
                            phone: '17659504938',
                            taobao: '',
                            _action: obj._action
                          });
                        }
                      },
                      {
                        text: '否',
                        fun() {
                          handler({
                            userid: 1222,
                            phone: '',
                            taobao: '',
                            _action: obj._action
                          });
                        }
                      }
                    ]
                  });
                } else {
                  MsgBox({
                    content: '是否已经绑定淘宝账号？',
                    btns: [
                      {
                        text: '是',
                        fun() {
                          handler({
                            userid: 1222,
                            taobao: 'taobao1212121',
                            phone: '',
                            _action: obj._action
                          });
                        }
                      },
                      {
                        text: '否',
                        fun() {
                          handler({
                            userid: 1222,
                            taobao: '',
                            phone: '',
                            _action: obj._action
                          });
                        }
                      }
                    ]
                  });
                }
              }
            },
            {
              text: '否',
              fun() {
                handler({
                  userid: '',
                  phone: '',
                  _action: obj._action
                });
              }
            }
          ]
        });
        break;
      case 'userUnbundling':
        handler({
          status: 1,
          _action: obj._action
        });
        break;
      case 'getExtraUrl':
        path = `${obj.action}.json`;
        connectNative(path, obj, handler);
        break;
      case 'getMapLocation':
        path = `${obj.action}.json`;
        connectNative(path, obj, handler);
        break;
      case 'getImmersiveStatusBarHeight':
        path = `${obj.action}.json`;
        connectNative(path, obj, handler);
        break;
      case 'xxEncode':
        path = `${obj.action}.json`;
        connectNative(path, obj, handler);
        break;
      case 'xxDecode':
        path = `${obj.action}.json`;
        connectNative(path, obj, handler);
        break;
      case 'logUserAction':
        console.log(`%c*离线统计: ${obj.para}`, 'color:blue;');
        break;
      case 'registerCallback':
        console.log('%c*Amap Bridge Init', 'color:green;');
        break;
      case 'webviewGoBack':
        history.back();
        break;
      case 'registRightButton':
      case 'registRightButtonNew':
        console.log(`%c*注册右上角按钮：${obj.buttonText}`, 'color:green;');
        break;
      case 'setWebViewCloseBtn':
        console.log('%c*隐藏关闭按钮', 'color:green;');
        break;
      case 'openAppUrl':
        location.href = obj.wapUrl;
        break;
      default:
        // chrome start
        if (window.AMAP_WEBSOCKET && window.AMAP_WEBSOCKET_MOCK) {
          // websocket mock 模式
          amap_chrome.send(obj);
        } else {
          console.warn(
            `未定义的action，请在 mock -> client 内创建 ${obj.action}.json`
          );
          path = `${obj.action}.json`;
          connectNative(path, obj, handler);
        }
      // chrome end
    }
  };

  connectNative = (path, params, fn) => {
    $.ajax({
      type: 'get',
      url: `/client/${path}`,
      dataType: 'json',
      success(data) {
        if (path.indexOf('getExtraUrl') >= 0) {
          if (data && data.div) {
            data._div = data.div.match(/\d+/);
            data._div = data._div && data._div.toString().replace(/^0+/, '') * 1;
          }
        }
        data._action = params._action;
        fn(data);
      }
    });
  };

  callAosHandler = (url, params, fn) => {
    $.ajax({
      type: 'get',
      url,
      dataType: 'string',
      success(data) {
        fn({
          _action: params._action,
          content: data
        });
      }
    });
  };

  fixURL = (url) => {
    const obj = new URL(url);
    return `${url.replace(obj.hostname, `${location.host}/aos`)}.json`;
  };
}

export default new AmapDebug();
